<template>
  <div class="title-edit">
    <fixed-header :title="(isEdit?'编辑':'新增')+'发票抬头'"></fixed-header>
    <div class="title-edit__main-wrap scroll-touch">
      <span style="display: none">{{ form.id }}</span>
      <InvoiceTitleDetail :invoice-info="form" :is-show="false"></InvoiceTitleDetail>
      <section class="title-edit__default">
        <div>设为默认抬头</div>
        <div>
          <mt-switch v-model="form.defaultState"></mt-switch>
        </div>
      </section>
    </div>
    <div class="title-edit__bottom" mg-stat-click mg-stat-custom="label=btn&cont=点击保存&direct=cntp&addr="
         mg-stat-mod="save_title" @click="submitForm">
      <button>保存</button>
    </div>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import InputItem from 'components/common/InputItem';
import InvoiceTitleDetail from 'components/invoice/title/detail';
import { removeSpaceChar } from 'utils/string';
import * as invoiceApis from 'apis/invoice';

export default {
  components: {
    FixedHeader,
    InputItem,
    InvoiceTitleDetail,
  },
  data() {
    const {
      id: titleId,
    } = this.$route.query;
    const nowId = titleId ? Number(titleId) : 0;
    return {
      isEdit: !!nowId,
      nowId,
      defaultState: false,
      form: this.initForm(),
    };
  },
  mounted() {
    this.getTitleInfo();
  },
  methods: {
    chooseTitleType(type) {
      this.form.type = type;
    },
    removeSpaceChar,
    initForm() {
      return {
        id: '',
        titleType: 0,
        invoiceTitle: '',
        taxpayer: '',
        address: '',
        phone: '',
        bankName: '',
        bankAccount: '',
        defaultState: false,
      };
    },
    async getTitleInfo() {
      if (this.nowId) {
        try {
          const data = await invoiceApis.titleInfo(this.nowId);
          if (data) {
            this.form = data;
            if (data.defaultState === 1) {
              this.form.defaultState = true;
            } else {
              data.defaultState = false;
            }
          }
        } catch (error) {
          const { message } = error;
          this.$toast(`获取发票抬头信息失败:${message}`);
        }
      }
    },
    toast(message) {
      this.$toast({
        message,
        duration: 1000,
      });
    },
    async submitForm() {
      const {
        form: {
          id,
          titleType,
          invoiceTitle,
          taxpayer,
          address,
          phone,
          bankName,
          bankAccount,
          defaultState,
        },
      } = this;
      if (!invoiceTitle) {
        this.toast('请填写抬头名称');
        return;
      }
      if (titleType === 0 && !taxpayer) {
        this.toast('请填写公司税号');
        return;
      }
      const form = {
        id,
        titleType,
        invoiceTitle,
        taxpayer,
        address,
        phone,
        bankName,
        bankAccount,
        defaultState: Number(defaultState),
      };
      this.$loading.open();
      try {
        await invoiceApis.saveTitleInfo(form);
        this.toast(this.isEdit ? '编辑成功' : '添加成功');
        this.$router.go(-1);
      } catch (error) {
        this.$message(`${error.message}`);
      }
      this.$loading.close();
    },
  },
};
</script>

<style lang="scss">

input::placeholder {
  font-size: 28px;
  font-family: PingFangSC;
  color: rgba(186, 186, 186, 1);
  line-height: 40px;
}

.title-edit {
  height: 100%;
  box-sizing: border-box;

  &__main {
    &-wrap {
      height: 100%;

      section {
        margin-top: 20px;
        padding: 0 30px;
        background: #fff;
      }
    }
  }


  &__default {
    height: 90px;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #000000;
    margin-bottom: 240px;
    justify-content: space-between;

    .mint-switch-core::before {
      background: #e5e5ea;
    }
  }

  &__bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 36px;
    background: #fff;

    button {
      padding: 20px 24px;
      width: 100%;
      font-size: 28px;
      color: #ffffff;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 40px;
    }
  }
}
</style>
